<script setup>
import { extractDate } from "@/utils/datetime.js"
import DatePicker from "@/components/DatePicker.vue"
import { ref, onMounted, nextTick, onBeforeUnmount } from "vue"
import emitter from "@/utils/emitter.js"
import { useEventStore } from "@/stores/EventsStore"
import { useModalStore } from "@/stores/ModalStore"
import { useCalendarStore } from "@/views/apps/calendar/useCalendarStore"
import { useDisplay } from "vuetify"
import SalonerTimePicker from "@/components/SalonerTimePicker.vue"


/* ---------------------------- 👉 Props ---------------------------- */
const props = defineProps({
  jumpToDateFc: Function,
})


/* ---------------------------- 👉 Stores ---------------------------- */
const eventStore = useEventStore()
const modalStore = useModalStore()
const calendarStore = useCalendarStore()

/* ---------------------------- 👉 Vuetify Mobile Breakpoint ---------------------------- */
const { mobile } = useDisplay()

/* ---------------------------- 👉 Refs ---------------------------- */


/* ---------------------------- 👉 Methods ---------------------------- */

/**
 * Handles date change on the calendar.
 * @param {Object} newDate - The new date data from the calendar.
 */
const handleDateChangeOnCalendar = (newDate) => {
  if (eventStore.allowSave && eventStore.getCalendarApi() && eventStore.getCalendarApi()?.view?.type === 'resourceTimeGridDay') {
    // Allow eventStore.selectedDate update only on day view
    eventStore.selectedDate = newDate.start
  }
}

/* ---------------------------- 👉 Lifecycle Hooks ---------------------------- */
onMounted(async () => {
  await nextTick()
  eventStore.setAllowEndTimeRecalculation(false)
  emitter.on('date-changed', handleDateChangeOnCalendar)
})

onBeforeUnmount(async () => {
  emitter.off('date-changed', handleDateChangeOnCalendar)
})
</script>

<template>
  <VRow
    dense
    class="mb-2 mt-3"
  >
    <VCol cols="6">
      <DatePicker
        :model-value="eventStore.selectedDate"
        :disabled="!eventStore.allowSave || eventStore.isSaving"
        class="mb-md-0 w-100"
        :inline="false"
        :set-icon="false"
        :label-text="$t('actions.form.select_date')"
        style="min-width: 125px"
        @update:model-value="(date) => eventStore.selectedDate = extractDate(date, '-')"
      />
    </VCol>
    <VCol cols="6">
      <SalonerTimePicker
        v-model="eventStore.selectedStartTime"
        :disabled="!eventStore.allowSave || eventStore.isSaving"
        :label="$t('pick_time')"
        density="compact"
        required
        :hours-from="calendarStore.calendarTimeFrom"
        :hours-to="calendarStore.calendarTimeTo"
        :hours-offset="1"
      />
    </VCol>
  </VRow>
</template>
